<template>
  <span class="d-inline" />
</template>

<script>
  import { format, addMinutes, parseISO } from 'date-fns';

  export default {
    name: 'Instant',
    data() {
      return {
        date: format(new Date(), 'yyyy-MM-dd'),
        time: format(addMinutes(new Date(), 1), 'HH:mm'),
      };
    },
    mounted() {
      this.$emit('input', {
        absolute: parseISO(`${this.date}T${this.time}`),
      });
    },
  };
</script>
